<div *ngIf="(pageVm$ | async) as pageVm">

    <app-page-header [vm]="pageVm" title='Credit Card Identity' [fullHeader]="true" [canAddNew]="true">
    </app-page-header>

    <div *ngIf="pageVm.contentVm as vm">

        <!-- customer CC ID entry -->
        <div *ngIf="vm.customerCcIdEntryVm as cvm">
            <app-credit-card-identity-capture [token]="cvm.token"></app-credit-card-identity-capture>
        </div>

        <!-- forms -->
        <div class="mt-3" *ngIf="vm.formVm as fvm">

            <!-- loading / error -->
            <div *ngIf="fvm.loadingError || (!fvm.loadingErrorText && fvm.loading)">
                <div class="row" >
                    <div class="col-md-12 text-center">
                        <div *ngIf="fvm.loadingError" class="text-danger text-center">
                            <div>{{fvm.loadingErrorText}}</div>
                            <div> 
                                <a class="underlined" href="javascript:null" (click)="formEnd(pageVm)">Back</a>
                            </div>
                        </div>
                        <div *ngIf="!fvm.loadingErrorText && fvm.loading">Loading...</div>
                    </div>
                </div>    
            </div>

            <!-- capture request form -->
            <div *ngIf="!fvm.loading && !fvm.loadingError">

                <!-- capture request -->
                <div class="row" *ngIf="fvm.type == 'capture-request'">
                    <div class="col-md-12">
                        <mdb-card narrower="true" cascade="true">
                            <div class="row">
                                <div class="col-md-6">
                                    <app-card-header [headingSize]="5" [title]="'New Request'">
                                    </app-card-header>
                                </div>
                            </div>
                            <mdb-card-body cascade="true">
                                <div class="row">
                                    <div class="col-md-3">
                                        <app-form-input [vm]="fvm.confirmationNumberInputVm"
                                            (textChanged)="requestFormValidate(vm, fvm)"></app-form-input>
                                    </div>
                                    <div class="col-md-4">
                                        <app-form-input [vm]="fvm.customerSmsInputVm"
                                            (textChanged)="requestFormValidate(vm, fvm)"></app-form-input>
                                    </div>
                                </div>
        
                                <div class="row">
                                    <div class="col-md-12">
                                        <app-form-input [vm]="fvm.notesInputVm"></app-form-input>
                                    </div>
                                </div>    
                            </mdb-card-body>
                        </mdb-card>
                        <app-form-ok-cancel *ngIf="fvm.okCancelVm" [vm]="fvm.okCancelVm" [isInvalid]="!fvm.isValid"
                            (cancelClicked)="formEnd(pageVm)" (okClicked)="requestFormOk(pageVm, vm, fvm)">
                        </app-form-ok-cancel>
                    </div>
                </div>
    
            </div>

        </div>

        <!-- main content -->
        <div *ngIf="!vm.formVm">
        </div>
    </div>

</div>